/** Namespace `bankPartners` — BANK-2026-038: đối tác ngân hàng của bube-banktransfer (chỉ dev). Bản gốc tiếng Việt. */
export const bankPartners = {
  hooksTitle: "Cửa vào theo đối tác",
  hooksIntro: "Mỗi đối tác một path riêng, kiểu khoá riêng. Lượt bị từ chối đếm theo lý do (sai / thiếu khoá, timestamp cũ) — tăng đột biến là cổng đối tác lệch khoá hoặc bị dội.",
  window24: "24 giờ",
  window168: "7 ngày",
  partner: "Đối tác",
  paths: "Path",
  accepted: "Đã nhận",
  rejected: "Bị từ chối",
  lastAccepted: "Nhận gần nhất",
  lastRejected: "Từ chối gần nhất {at}",
  noAdapter: "chưa có adapter",
  none: "—",
  billingTitle: "Đình chỉ & lệch tính phí",
  billingIntro: "Kết nối bị Bube đình chỉ, và kết nối mà lệnh ngừng / bật tính phí ở đối tác chưa xong hoặc không tự làm được (đang dừng ở bube mà đối tác có thể vẫn tính phí).",
  billingEmpty: "Không có kết nối nào cần xử lý.",
  connection: "Kết nối",
  workspace: "Công ty",
  status: "Trạng thái",
  billingState: "Tính phí ở đối tác",
  suspension: "Đình chỉ",
  "state.pending": "đang báo đối tác",
  "state.failed": "báo hỏng — đang thử lại",
  "state.unsupported": "không tự làm được — xử lý tay",
  "state.done": "xong",
  "state.not_needed": "không cần",
  "desired.stopped": "ngừng",
  "desired.running": "chạy",
  "reason.unpaid": "Nợ phí",
  "reason.service": "Ngừng dịch vụ",
  "reason.fraud": "Nghi gian lận",
  reasonHint: "Nợ phí / ngừng dịch vụ ⇒ ngừng ở đối tác. Nghi gian lận ⇒ đối tác vẫn gửi (giữ làm bằng chứng), không phát cho khách.",
  suspendTitle: "Đình chỉ một kết nối",
  connectionId: "ID kết nối (pcn_…)",
  reason: "Lý do",
  note: "Ghi chú (tuỳ chọn)",
  suspend: "Đình chỉ",
  lift: "Gỡ đình chỉ",
  confirmLift: "Gỡ đình chỉ kết nối {id}? Kết nối trở về trạng thái trước khi bị đình chỉ.",
  done: "Đã ghi.",
  auditTitle: "Đối chiếu VA Tingee ⇄ kết nối",
  auditIntro: "Gọi Tingee THẬT bằng khoá Live (chỉ đọc). Để trống Merchant ID ⇒ bube-banktransfer tự tìm (danh sách merchant nếu khoá có quyền, không thì từ giao dịch 10 ngày gần nhất).",
  merchantId: "Merchant ID",
  merchantIdAuto: "trống = tự tìm",
  merchantIdInvalid: "Merchant ID phải là số nguyên dương.",
  merchantsUsed: "Merchant đã quét: {ids}",
  "source.given": "nhập tay",
  "source.merchant_api": "tự tìm qua danh sách merchant của Tingee",
  "source.transactions": "tự tìm qua giao dịch 10 ngày gần nhất",
  runAudit: "Đối chiếu",
  running: "Đang đối chiếu…",
  scanned: "Đã quét {n} VA ở Tingee",
  truncated: "Chạm trần quét — mục « thiếu ở Tingee » không kết luận.",
  orphan: "VA mồ côi ở Tingee (bube không có kết nối — có thể vẫn bị tính phí)",
  missing: "Kết nối bube đang nhận mà Tingee không còn VA",
  mismatch: "Lệch trạng thái (Tingee không active, bube active)",
  clean: "Khớp hết.",
  loadFailed: "Không đọc được bube-banktransfer.",
  failed: "Không thực hiện được.",
} as const;
